import React from 'react';
import { Link } from 'react-router-dom';
import { COMPANY } from '../../../data';

/**
 * Logo component with error handling and fallback
 * @param {Object} props
 * @param {string} props.src - Logo image source (deprecated, use variant instead)
 * @param {string} props.variant - Logo variant: 'default' | 'transparent' | 'white'
 * @param {string} props.alt - Alt text for logo
 * @param {string} props.className - Additional CSS classes
 * @param {string} props.fallbackText - Text to show if image fails
 * @param {boolean} props.linkTo - Whether to wrap in Link component
 * @param {string} props.linkPath - Path for Link component
 * @returns {JSX.Element}
 */
export const Logo = ({ 
  src,
  variant = 'default',
  alt = COMPANY.shortName + ' Logo',
  className = 'h-16 w-auto',
  fallbackText = COMPANY.shortName,
  linkTo = true,
  linkPath = '/'
}) => {
  // Choose logo based on variant
  const getLogoSource = () => {
    switch (variant) {
      case 'transparent':
        return COMPANY.logoTransparent;
      case 'white':
        return COMPANY.logoWhite;
      default:
        return COMPANY.logo;
    }
  };

  const logoSource = getLogoSource();
  const [imageError, setImageError] = React.useState(false);

  const handleImageError = (e) => {
    setImageError(true);
    e.target.style.display = 'none';
  };

  const logoContent = (
    <>
      {!imageError && (
        <img 
          src={logoSource} 
          alt={alt} 
          className={className}
          onError={handleImageError}
        />
      )}
      {imageError && (
        <div className={`w-20 h-8 bg-primary-600 rounded-lg flex items-center justify-center ${className}`}>
          <span className="text-white font-bold text-sm">{fallbackText}</span>
        </div>
      )}
    </>
  );

  if (linkTo) {
    return (
      <Link to={linkPath} className="flex items-center">
        {logoContent}
      </Link>
    );
  }

  return <div className="flex items-center">{logoContent}</div>;
}; 